// src/utils/loading.js
import { Loading } from 'element-ui';

// loading.js
let loading;
let needLoadingRequestCount = 0;

export function startLoading() {
  loading = Loading.service({
    lock: true,
    text: 'Loading...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.5)',
    target: document.querySelector('.main') || document.body
  });
}

export function endLoading() {
  if (loading) {
    loading.close();
  }
}

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}
